import { Component, Input } from '@angular/core';
import { ThemePalette } from '@angular/material/core';

@Component({
  selector: 'ui-progress-meter',
  templateUrl: './progress-meter.component.html',
  styleUrls: ['./progress-meter.component.scss'],
})
export class ProgressMeterComponent {
  @Input() public color: ThemePalette = 'accent';
  @Input() public isMeterActive = false;
  @Input() public isSticky = false;
}
